// extracted by mini-css-extract-plugin
export var arrows = "_21-5";
export var decrementer = "_21-9";
export var disabled = "_21-3";
export var error = "_21-1";
export var hiddenText = "_21-a";
export var incrementer = "_21-8";
export var input = "_21-7";
export var inputWrapper = "_21-0";
export var leadingIcon = "_21-b";
export var readonly = "_21-2";
export var regular = "_21-6";
export var small = "_21-4";